"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var penguinEgg = {
    name: "penguin",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["p", "e", "n", "g", "u", "i", "n"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/lkcElNE.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "374px";
        img.style.height = "375px";
        img.style.transition = "13s all";
        img.style.position = "fixed";
        img.style.right = "-374px";
        // img.style.bottom = 'calc(-50% + 280px)';
        img.style.bottom = "0px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.right = "calc(100% + 500px)";
        }, 50);
        // window.setTimeout(function(){
        //   img.style.right = 'calc(100% + 375px)';
        // }, 4500);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 10300);
    },
};
exports.default = penguinEgg;
